import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

interface LogoProps {
  variant?: 'default' | 'small' | 'large';
  showText?: boolean;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  variant = 'default', 
  showText = true, 
  color = 'primary' 
}) => {
  const getSizeStyles = () => {
    switch (variant) {
      case 'small':
        return { imgSize: 32, fontSize: '1.5rem', boxMr: 0.75 };
      case 'large':
        return { imgSize: 48, fontSize: '2.5rem', boxMr: 1.5 };
      default:
        return { imgSize: 40, fontSize: '2rem', boxMr: 1 };
    }
  };
  
  const styles = getSizeStyles();

  return (
    <Box 
      component={Link}
      to="/"
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Box 
        component="img"
        src="/logo.png"
        alt="Kivity Logo"
        sx={{
          width: styles.imgSize,
          height: styles.imgSize,
          mr: showText ? styles.boxMr : 0,
          borderRadius: '50%',
          objectFit: 'cover',
        }}
      />
      {showText && (
        <Typography 
          variant="h4"
          component="span"
          sx={{ 
            fontWeight: 800,
            fontSize: styles.fontSize,
            letterSpacing: '-0.02em',
            fontFamily: '"Inter", "SF Pro Display", "Poppins", -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
            background: 'linear-gradient(135deg, #06B6D4 0%, #8B5CF6 50%, #EC4899 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textFillColor: 'transparent',
            lineHeight: 1.2,
          }}
        >
          Kivity
        </Typography>
      )}
    </Box>
  );
};

export default Logo; 